import React from 'react'
import PropTypes from 'prop-types'


export default function Navbar(props) {

return (
        <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <a className="navbar-brand" href="/"> {props.title}</a>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav mr-auto">
                </ul>
                    <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" onClick={props.togglemode} id="flexSwitchCheckChecked"/>
                    <label className="form-check-label" htmlFor="flexSwitchCheckChecked">Dark Mode</label>
                    </div>
            </div>
        </nav>
   )  
}  
Navbar.propTypes = {
    title:PropTypes.string.isRequired,
    about:PropTypes.string.isRequired
}



// WEBPACK FOOTER //
// ./src/components/Navbar.js